module.exports = __webpack_public_path__ + "img/safety-summary-error.de59db4d.svg";